
  Vue.component('user-invites-manager', {
    props: {
      visible: { type: Boolean, default: true }
    },
    data() {
      return {
        currentPage: 1,
        formInterfaces: {},
        pageflow: '',
        contactList: [],
        newContactId: null,
        defaultFieldValue: {},
        relationshipType: null,
        broadcastUrl: null,
        widgetList: []
      }
    },
    template: '#user-invites-manager',
    computed: {
      pages() {
        const retVal = [
          {
            id: 10,
            code: 'nuovo',
            label: 'Invita un utente',
            title: `Invita un utente`,
            subTitle: `Inserisci qui sotto gli indirizzi mail dei tuoi contatti per invitarli a compilare il proprio cv su LearK.<br /> Per inviare più richieste, separa gli indirizzi email con un punto e virgola. Es. miamail@dominio.it; altramail@domain.com`,
            titleIcon: 'fa-users-medical fa-swap-opacity'
          },
          {
            id: 20,
            code: 'elenco',
            label: 'I tuoi contatti',
            title: 'Gestisci i tuoi contatti',
            subTitle: 'Controlla lo stato dei tuoi inviti ',
            titleIcon: 'fa-users-cog'
          }
        ]
        return retVal.sort((a, b) => (a.id > b.id ? 1 : -1))
      },
      currentPageCode() {
        return this.pages[this.currentPage - 1].code
      }
    },
    watch: {},
    methods: {
      nextPage(e, pageNumber) {
        if (this.currentPage < this.pages.length) {
          this.pageflow = ''
          if (pageNumber) {
            setTimeout(() => (this.currentPage = pageNumber), 100)
          } else {
            setTimeout(() => this.currentPage++, 100)
          }
        } else {
          console.log('Ultima Pagina')
        }
      },
      previousPage(e, pageNumber) {
        this.pageflow = '-back'
        if (pageNumber) {
          setTimeout(() => (this.currentPage = pageNumber), 100)
        } else if (this.currentPage > 1) {
          setTimeout(() => this.currentPage--, 100)
        }
      },
      stopAll(event) {
        event.stopPropagation()
        event.preventDefault()
        return false
      },
      beforeEnter: () => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      },
      getFormInterface(formInterface) {
        this.formInterfaces[formInterface.key] = formInterface
      },
      getErrorResponse(error) {
        let retVal = error
        if (error.response) {
          retVal = { status: error.response.status }
          if (error.response.data && error.response.data.error) {
            retVal = {
              ...retVal,
              ...error.response.data.error
            }
          }
        }
        return retVal
      },
      sendRequest() {
        const key = 'UserInvites'
        const self = this
        if (this.formInterfaces[key].validate()) {
          if (!this.formInterfaces[key].fieldsAreChange()) {
            self.nextPage()
          } else if (this.formInterfaces[key].fieldsAreChange()) {
            const formValue = self.formInterfaces[key].getValues()
            axios
              .post(`/api/v1/seekers-user-invites/new`, formValue)
              .then(response => {
                const { data } = response
                self.newContactId = data.Id
                EventBus.$emit('vnShow', {
                  type: 'success',
                  message: `l'invito è stato spedito correttamente`
                })
                self.nextPage()
              })
              .catch(error => {
                const errorResponse = self.getErrorResponse(error)
                if (errorResponse.status === 401) {
                  self.handleSessionExpired()
                } else {
                  if (errorResponse.notEligible && errorResponse.notEligible > 0) {
                    EventBus.$emit('vnPopup', {
                      message: `<h5 class="text-left weight-600"><p><b>Questi utenti risultano già iscritti a Leark in una categoria diversa da quella dei candidati:</b></p><p>${errorResponse.notEligible.join(
                        '<br />'
                      )}</p></h5>`,
                      actions: [{ label: 'Ok', icon: 'fa-check', style: 'success' }]
                    })
                  }
                  if (errorResponse.alreadyInvited && errorResponse.alreadyInvited.length > 0) {
                    EventBus.$emit('vnPopup', {
                      type: 'warning',
                      message: `<h5 class="text-left weight-600"><p><b>Questi contatti hanno già ricevuto un invito:</b></p><p>${errorResponse.alreadyInvited.join(
                        '<br />'
                      )}</p><p class="mt-2">Vuoi spedire un nuovo invito?</p></h5>`,
                      actions: [
                        {
                          label: 'OK',
                          icon: 'fa-check-circle',
                          action: () => {
                            formValue.EmailList = errorResponse.alreadyInvited.join(';')
                            self.reSend(event, formValue)
                          },
                          style: 'success'
                        },
                        { label: 'Annulla', icon: 'fa-times-circle', style: 'info' }
                      ]
                    })
                  } else {
                    EventBus.$emit('vnShow', {
                      type: 'danger',
                      message: `Le modifiche non sono state salvate: ${error}`
                    })
                  }
                }
              })
              .then(() => {
                // always executed
              })
          }
        }
      },
      handleReSend(event, item) {
        const self = this
        const formValue = { EmailList: item.ContactEmail }
        EventBus.$emit('vnPopup', {
          style: 'popup',
          type: 'light',
          message: `Vuoi spedire un nuovo invito al contatto selezionato?`,
          component: self.widgetList.length > 1 ? 'user-invites-resend-popup' : '',
          options: { widgetList: self.widgetList },
          actions: [
            {
              label: 'OK',
              icon: 'fa-check-circle',
              action: () => {
                formValue.WidgetId = EventBus.selectedWidgetId
                this.reSend(event, formValue)
                delete EventBus.selectedWidgetId
              },
              style: 'success'
            },
            { label: 'Annulla', icon: 'fa-times-circle', style: 'info' }
          ]
        })
      },
      reSend(event, formValue) {
        const self = this
        axios
          .post(`/api/v1/seekers-user-invites/resend`, formValue)
          .then(response => {
            const { data } = response
            self.nextPage(null, 1)

            EventBus.$emit('vnShow', {
              type: 'success',
              message: `Gli inviti sono stati spediti correttamente.`
            })
          })
          .catch(error => {
            const errorResponse = self.getErrorResponse(error)
            if (errorResponse.status === 401) {
              self.handleSessionExpired()
            } else {
              EventBus.$emit('vnShow', {
                type: 'danger',
                message: `Gli inviti non sono stati spediti: ${error}`
              })
            }
          })
          .then(() => {
            // always executed
          })
      },
      getDefault() {
        const self = this
        axios
          .get(`/api/v1/seekers-relationships/seekerdefault/`)
          .then(response => {
            const { data } = response

            self.relationshipType = data.relationshipType
            self.defaultFieldValue = { ...self.defaultFieldValue, ContactMessage: data.defaultMessage }
            self.broadcastUrl = data.broadcastUrl
            self.widgetList = data.widget
            self.seekerUserInvitesFormRequest[0].options = data.widget.map(wid => ({
              ...wid,
              valueIfChecked: `${wid.id}`
            }))
            self.seekerUserInvitesFormRequest[0].value = `${data.widget[0].id}`
            self.seekerUserInvitesFormRequest[0].inputType = data.widget.length === 1 ? 'hidden' : 'radio'
          })
          .catch(error => {
            self.error = true
          })
          .then(() => {
            // always executed
          })
      },
      handleSessionExpired() {
        EventBus.$emit('vnPopup', {
          type: 'danger',
          message: `<p><b>La sessione è scaduta</b></p><p>La pagina verrà ricaricata per permettere di effettuare nuovamente il login</p>`,
          actions: [
            {
              label: 'OK',
              icon: 'fa-check-circle',
              action: () => {
                window.location.reload()
              },
              style: 'danger'
            }
          ]
        })
      }
    },
    mounted() {
      this.getDefault()
      // EventBus.$on('vnShow', this.vnShow)
    },
    beforeDestroy() {
      // EventBus.$off('vnShow', this.vnShow)
    }
  })
